import { useTranslation } from 'react-i18next';
import {
  useDepartmentCreateMutation,
  useDepartmentUpdateMutation,
} from 'graphql-common';
import { showGraphQLErrors } from '@lib/utils/graphQLErrors';

export default function useMutations() {
  const { t } = useTranslation();

  const [departmentCreateMutation, departmentCreateMutationResult] =
    useDepartmentCreateMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });
  const [departmentUpdateMutation, departmentUpdateMutationResult] =
    useDepartmentUpdateMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  return {
    departmentCreateMutation,
    departmentCreateMutationResult,
    departmentUpdateMutation,
    departmentUpdateMutationResult,
  };
}
